import { ArrowForwardIos, ContentCopy, Delete, SupportAgent } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

const COLOR = "#0369a1";
const BG = "#e0f2fe";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);
  const cfg = data?.data || data;

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "280px",
        maxWidth: "280px",
        width: "280px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: `2px solid ${isHovered ? COLOR : "#e5e7eb"}`,
        boxShadow: isHovered ? `0 12px 32px rgba(3,105,161,.14)` : "0 4px 16px rgba(0,0,0,.06)",
        transition: "all 0.2s ease",
        transform: isHovered ? "translateY(-2px)" : "translateY(0)",
        userSelect: "none",
      }}
    >
      <Handle type="target" position="left"
        style={{ background: COLOR, width: 16, height: 16, left: -10, border: "3px solid #fff" }}
        isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2.5px", mb: "0.5px", pointerEvents: "none" }} />
      </Handle>

      <div style={{ position: "absolute", right: 16, top: 16, display: "flex", gap: 8, opacity: isHovered ? 1 : 0, transition: "opacity .2s" }}>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <ContentCopy sx={{ width: 14, height: 14, color: "#6b7280" }} />
        </div>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <Delete sx={{ width: 14, height: 14, color: "#ef4444" }} />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #f3f4f6" }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${COLOR}, #0284c7)`, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, boxShadow: `0 4px 12px rgba(3,105,161,.25)`, flexShrink: 0 }}>
          <SupportAgent sx={{ width: 18, height: 18, color: "#fff" }} />
        </div>
        <div>
          <div style={{ color: "#111827", fontSize: 16, fontWeight: 700 }}>SGP — Abrir Chamado</div>
          <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 500 }}>Abre OS no SGP</div>
        </div>
      </div>

      <div style={{ background: BG, padding: 12, borderRadius: 10, border: `1px solid #bae6fd`, marginBottom: 16 }}>
        <div style={{ fontSize: 12, color: "#0c4a6e", fontWeight: 600 }}>Contrato</div>
        <div style={{ fontSize: 13, color: COLOR, fontWeight: 700, marginTop: 2 }}>
          {`{{${cfg?.contratoVar || "sgp_contrato_id"}}}`}
        </div>
        {cfg?.conteudo && (
          <div style={{ fontSize: 11, color: "#475569", marginTop: 6, borderTop: "1px solid #bae6fd", paddingTop: 6, lineHeight: 1.4, maxHeight: 40, overflow: "hidden" }}>
            {cfg.conteudo}
          </div>
        )}
      </div>

      {[
        { id: "criado",    label: "Criado",       color: "#22c55e", top: "38%" },
        { id: "ja_existe", label: "Já existe",    color: "#f59e0b", top: "58%" },
        { id: "erro",      label: "Erro",         color: "#ef4444", top: "78%" },
      ].map(h => (
        <React.Fragment key={h.id}>
          <Handle type="source" position="right" id={h.id}
            style={{ background: h.color, width: 16, height: 16, right: -10, top: h.top, border: "3px solid #fff" }}
            isConnectable={isConnectable}>
            <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2px", mb: "0.5px", pointerEvents: "none" }} />
          </Handle>
          <div style={{ position: "absolute", right: 20, top: `calc(${h.top} - 8px)`, fontSize: 10, fontWeight: 700, color: h.color, whiteSpace: "nowrap" }}>
            {h.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
});
